import {
  requestDecrement,
  requestIncrement,
} from '../actions/requests-counter';

export const requestsCounter = (store) => (next) => (action) => {
  if (typeof action === 'function') {
    const wrap = (...args) => {
      const result = action(...args);

      if (!(result instanceof Promise)) {
        return result;
      }

      store.dispatch(requestIncrement);
      return result.then(
        (response) => {
          store.dispatch(requestDecrement);
          return response;
        },
        (reason) => {
          store.dispatch(requestDecrement);
          return Promise.reject(reason);
        },
      );
    };

    return next(wrap);
  }

  return next(action);
};
